import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { PbiRoutingModule } from './pbi-routing.module';
import { ComponentsModule } from "../components/components.module";
import { SharedModule } from '../shared.module';
import { SampleModule } from "./sample/sample.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    SharedModule,
    SampleModule,
    PbiRoutingModule
  ]
})
export class PbiModule {}
